const { body } = document;
const html = document.querySelector('html');

function _blockScroll(event) {
  event.preventDefault();
  event.stopPropagation();
}

export default class ScrollLock {
  static lock() {
    html.classList.add('scroll-locked');
    body.style.top = -1 * window.pageYOffset;
    body.addEventListener('scroll', _blockScroll, false);
    body.addEventListener('touchmove', _blockScroll, { passive: false });
  }

  static unlock() {
    html.classList.remove('scroll-locked');
    body.style.top = '';
    body.removeEventListener('scroll', _blockScroll, false);
    body.removeEventListener('touchmove', _blockScroll, { passive: false });
  }
}
